import Logger from './lib/Logger.mjs';
import SentryLogger from './lib/SentryLogger.mjs';
import transports, { ConsoleTransport, SentryTransport } from './lib/transports/index.mjs';

let rootLogger = null;

/**
 * Factory method for creating root application logger. On first call, the root logger is set.
 *
 * @param {SentryLoggerOptions} opts
 * @returns {Logger}
 */
const createLogger = (opts = {}) => {
  let classToInit = Logger;
  if (opts.sentry) {
    classToInit = SentryLogger;
  }
  const logger = classToInit.initialize(opts);

  // first time called set root logger
  // we can also pass in
  if (!rootLogger) {
    rootLogger = logger;
  }
  /* c8 ignore next */
  return logger;
};

/**
 * Default module method for getting contextual logger. If rootLogger has been set via createLogger(), than a child
 * logger will be created. If there is not root logger, a default Logger will be instantiated with passed context.
 *
 * @param context
 * @returns {Logger}
 */
const getLogger = (context = {}) => {
  // if no root logger, we just return a default Logger
  if (!rootLogger) {
    return Logger.initialize({ context });
  }
  return rootLogger.child(context);
};

export {
  getLogger as default,
  ConsoleTransport,
  createLogger,
  getLogger,
  Logger,
  SentryLogger,
  SentryTransport,
  transports
};
